import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { isEmpty, map } from "lodash"
import Dropzone from "react-dropzone"
import { addProjectGallery, getProjectGallary, deleteProjectGallery, getProjectUUIDAction } from "../../../../store/projects/actions"
import { BlobServiceClient } from '@azure/storage-blob';
import { azureConfig } from "../../../../helpers/azureConfig";
import Swal from 'sweetalert2'
import {
  Row,
  Col,
  Card,
  Form
} from "reactstrap"
//Import Breadcrumb
import { classnames } from "helpers/helper";
import { UPLOADTEXT } from "constants/layout"


class ProjectsInteriorGallery extends Component {
  constructor(props) {
    super(props)
    //this.imageInputRef = React.useRef();
    this.state = {
     
      selectedFiles: [],
      image:'',
     
      
    }
  
   
    this.handleAcceptedFiles = this.handleAcceptedFiles.bind(this)
   
  }
 
  handleAcceptedFiles = async (acceptedFiles) => {
    const filesWithPreview = acceptedFiles.map(file => {
      file.preview = URL.createObjectURL(file);
      file.formattedSize = this.formatBytes(file.size);
      return file;
    });

    this.setState({ selectedFiles: filesWithPreview });

    filesWithPreview.forEach(file => this.uploadFileToAzure(file));
  };

  uploadFileToAzure = async (file) => {
    const maxSize = 2 * 1024 * 1024; // 5 MB
    const allowedTypes = [
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/svg+xml',
          ];

          const allowedExtensions = ['.jpg', '.jpeg', '.png', '.webp', '.svg'];
    const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

  // Validate file type
  if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
    Swal.fire({
      title: 'File type or extension not allowed',
      text: 'Please upload a JPG, PNG, WEBP, SVG file.',
      icon: 'warning',
      confirmButtonText: 'OK',
    });
    return;
  }

  // Validate file size
  if (file.size > maxSize) {
    Swal.fire({
      title: 'File size exceeded',
      text: 'Please upload a file smaller than 2MB.',
      icon: 'warning',
      confirmButtonText: 'OK',
    });
    return;
  }
    const sasToken = azureConfig.sasToken
    const containerName = azureConfig.containerName;
    const accountName = azureConfig.storageAccountName;
   

    const blobServiceClient = new BlobServiceClient(
      `https://${accountName}.blob.core.windows.net?${sasToken}`
    );
    const fileName = `${Date.now()}_${file.name}`;
    const containerClient = blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    try {
      await blockBlobClient.uploadBrowserData(file);
    const fileUrl = `https://${accountName}.blob.core.windows.net/${containerName}/${fileName}`;
    const data = {
        'projectId': parseInt(this.props.projectData.id),
        'projectGuid': this.props.projectData.preConsProjectGuid,
        'agentId': parseInt(localStorage.getItem('userId')),
        'projectGalleryTitle' : fileName,
        'projectGalleryLink' : fileUrl,
        'projectGalleryTypeId' : 2
    }
    this.props.addProjectGallery(data, this.props.history);
    } catch (error) {
      console.error('Error uploading file to Azure Blob Storage', error);
    }
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

 
  
 
  render() {
    const { projectData } = this.props;
      return (
      <React.Fragment>
        <Form>
                  <Dropzone onDrop={this.handleAcceptedFiles}>
          {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="mb-3">
                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                </div>
                <h4>Drop files here or click to upload.</h4>
                <h5>{UPLOADTEXT.GIMG}</h5>
              </div>
            </div>
          )}
                    </Dropzone>
                       
                    </Form>

                  
      </React.Fragment>
    )
  }
}

ProjectsInteriorGallery.propTypes = {
  t:PropTypes.any,
  history:PropTypes.object,
  match:PropTypes.object,
  addProjectGallery:PropTypes.func,
  projectData:PropTypes.object
 
 
}

const mapStateToProps = ({ Project }) => ({
 
})

const mapDispatchToProps = dispatch => ({
  addProjectGallery: (data) => dispatch(addProjectGallery(data)),
 
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withTranslation()(ProjectsInteriorGallery)))